/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.admin.sendEmail'

export { $nsid }

/** Send email to a user's account email address. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    recipientDid: l.string({ format: 'did' }),
    content: l.string(),
    subject: l.optional(l.string()),
    senderDid: l.string({ format: 'did' }),
    comment: l.optional(l.string()),
  }),
  l.jsonPayload({ sent: l.boolean() }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
